import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthGuardService as AuthGuard} from './services/authguard.service';
import {AppComponent} from './app.component';
import {LoginComponent} from './external/login/login.component';
import {CapitalizePipe} from './shared/pipes/capitalizefirst.pipe';
import {AppRoutingModule} from './app-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {LoadingModule} from 'ngx-loading';
import {ApiService} from './services/api.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AngularFontAwesomeModule} from 'angular-font-awesome';
import {ToastrModule} from 'ngx-toastr';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {InterceptorService} from './services/interceptor.service';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {LightboxModule} from 'ngx-lightbox';
import {AsyncPipe} from '@angular/common';
import {ClickOutsideModule} from 'ng-click-outside';
import {TermsComponent} from './external/terms/terms.component';
import {PrivacyComponent} from './external/privacy/privacy.component';
import {Ng2TelInputModule} from 'ng2-tel-input';
import {ExternalAuthguardService} from './services/externalAuthguard.service';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {GooglePlaceModule} from 'ngx-google-places-autocomplete';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import {ReferralComponent} from './external/referral-code/referral.component';
import { ForgotComponent } from './external/forgot/forgot.component';
import { ResetPasswordComponent } from './external/reset-password/reset-password.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/**
 * Multilanguage Support 
 * Added by Harendra Singh Rawat 
 * Added on 01,Aug 2022
 ************************************************************************************************
 */
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateService } from '@ngx-translate/core'
declare var jQuery: any;

@NgModule({
    declarations: [
        CapitalizePipe,
        AppComponent,
        LoginComponent,
        TermsComponent,
        PrivacyComponent,
        ReferralComponent,
        ForgotComponent,
        ResetPasswordComponent,
  
    ],
    imports: [
        PaginationModule.forRoot(),
        GooglePlaceModule,
        Ng2TelInputModule,
        BrowserModule,
        ClickOutsideModule,
        AppRoutingModule,
        HttpClientModule,
         TranslateModule.forRoot({
            loader: {
              provide: TranslateLoader,
              useFactory: createTranslateLoader,
              deps: [HttpClient]
            }
        }),
        FormsModule, 
        ReactiveFormsModule,
        LoadingModule.forRoot({
            primaryColour: '#4D6836',
            tertiaryColour: '#4D6836'
        }),
        ServiceWorkerModule.register('/ngsw-worker.js', {
            enabled: environment.production
        }),
        CommonModule,
        BrowserAnimationsModule,
        AngularFontAwesomeModule,
        ToastrModule.forRoot({
            closeButton: true,
            timeOut: 3000,
            progressAnimation: 'increasing',
            preventDuplicates: true,
            resetTimeoutOnDuplicate: true,
            progressBar: true
        }),
        LazyLoadImageModule,
        LightboxModule,
        NgMultiSelectDropDownModule.forRoot(),
        BsDatepickerModule.forRoot(),
        ModalModule.forRoot(),
        NgbModule       

    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true
        },
        ApiService,
        AuthGuard,
        AsyncPipe,
        ExternalAuthguardService
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
    constructor(public translate: TranslateService,public api: ApiService,) { 
        var lang = localStorage.getItem('lang') ||'en';
        translate.addLangs(['en', 'ar']);
        api.currentLanugae = lang;
        translate.use(lang ||'en');

        if(lang == 'ar') {
            jQuery('body').addClass('right-to-left');
            jQuery('body').attr("dir","rtl");
            jQuery('body').attr("lang","ar");
        }
        else{
            jQuery('body').removeClass('right-to-left');
            jQuery('body').attr("dir","ltr");
            jQuery('body').attr("lang","en");
        }

    } 
}

/*  export function createTranslateLoader(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
} */
export function createTranslateLoader(http: HttpClient) {    return new TranslateHttpLoader(http, './assets/i18n/', '.json');}
  